export const name = 'builderComponent' as const
